module.exports = __webpack_public_path__ + "static/img/food_menu_bg.27fea9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/food_menu_bg.jpg
// module id = ATo3
// module chunks = 0